<app-notification-bar
  [notificationGroups]="notificationGroups$ | async"
  maxHeight="160px"
  (remove)="onRemove($event)"></app-notification-bar>
